export default __webpack_public_path__ + "static/media/paso24.15572987.png";